import styled from 'styled-components';
import {
  HrFontBold,
  HrPrimary,
  HrSecondary,
  HrTransition,
  HrTransitionDuration,
  HrTransitionTimingCunction
} from '@components/styles/hr-styles';

export const TabItem = styled.div`
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: ${HrSecondary};
  cursor: pointer;
  transition: font-weight ${HrTransitionDuration} ${HrTransitionTimingCunction};

  &.active {
    color: ${HrPrimary};
    font-weight: ${HrFontBold};
  }

  & div {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 0;
    transition: ${HrTransition};
    transition-property: height;
    background-color: ${HrPrimary};
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
  }

  & div.active {
    height: 6px;
  }
`;
